export default {
  'messages.title': 'Messages',
  'messages.no_messages': 'Pas de messages',
  'messages.no_conversations': 'Vous n\'avez pas encore de conversations',
  'messages.start_conversation': 'Commencer une conversation',
  'messages.loading_conversation': 'Chargement de la conversation...',
  'messages.send': 'Envoyer',
  'messages.type_message': 'Tapez votre message...',
  'messages.book_appointment': 'Réserver un rendez-vous',
  'messages.back_to_conversations': 'Retour aux conversations',
  'messages.starting_conversation': 'Démarrage de la conversation',
  'messages.please_wait': 'Veuillez patienter...',
  'messages.conversation_created': 'Conversation créée',
  'messages.send_first_message': 'Envoyez votre premier message!',
  'messages.error': 'Erreur',
  'messages.error_starting_conversation': 'Erreur lors du démarrage de la conversation',
  'messages.error_sending_message': 'Erreur lors de l\'envoi du message',
  'messages.load_more': 'Charger plus',
  'messages.no_more_messages': 'Pas plus de messages',
  'messages.conversation_with': 'Conversation avec',
  'messages.online': 'En ligne',
  'messages.offline': 'Hors ligne',
  'messages.booking_confirmed': 'Réservation confirmée',
  'messages.booking_failed': 'Échec de la réservation',
  'messages.booking_info': 'Informations de réservation',
  'messages.date': 'Date',
  'messages.time': 'Heure',
  'messages.duration': 'Durée',
  'messages.price': 'Prix',
  'messages.payment_method': 'Méthode de paiement',
  'messages.payment_status': 'Statut du paiement',
  'messages.booking_status': 'Statut de la réservation',
  'messages.booking_details': 'Détails de la réservation',
  'messages.confirm_booking': 'Confirmer la réservation',
  'messages.cancel_booking': 'Annuler la réservation',
  'messages.booking_success': 'Réservation réussie',
  'messages.booking_pending': 'Réservation en attente',
  'messages.booking_cancelled': 'Réservation annulée',
  'messages.payment_pending': 'Paiement en attente',
  'messages.payment_completed': 'Paiement effectué',
  'messages.payment_failed': 'Échec du paiement',
  'messages.archive': 'Archiver',
  'Messages': 'Messages',
  'messages.status_offline': 'Hors ligne',
  'messages.book_button': 'Réserver',
  'messages.hide_conversation': 'Masquer la conversation',
  'messages.input_placeholder': 'Écrivez votre message ici...',
  'messages.delete_message': 'Supprimer le message',
  'messages.send_failed': 'Échec de l\'envoi du message.',
  'messages.loading': 'Chargement des messages...',
  'messages.search_placeholder': 'Rechercher une conversation...',
  'messages.hide_conversation_error': 'Impossible de masquer la conversation. Veuillez réessayer.'
}; 